var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"slide-bottom"}},[(_vm.value)?_c('div',{class:['ui-notification', { error: _vm.error }]},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }